import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtogoacab() {



    const cardData = {


keyword: "Belgaum to Goa Cab",

headingDescription: "Belgaum Taxi Service provides safe, comfortable, and affordable Belgaum to Goa cab services for family vacations, beach holidays, corporate travel, airport transfers, weekend getaways, hotel transfers, and group tours. Whether you need a one-way taxi from Belgaum to Goa or a round-trip cab, we offer well-maintained vehicles with experienced chauffeurs to ensure a smooth and enjoyable journey. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles according to your travel requirements. We provide doorstep pickup, flexible departure timings, transparent pricing, online booking, and 24/7 customer support for a hassle-free travel experience. Belgaum Taxi Service covers all major Goa destinations including North Goa, South Goa, beaches, resorts, airports, railway stations, and tourist attractions, making us a trusted choice for Belgaum to Goa taxi bookings.",

topPlaces: [
  {
    title: "Calangute Beach",
    description: "Calangute Beach is one of Goa's most famous tourist attractions, known for its golden coastline, water sports, restaurants, shopping streets, and vibrant atmosphere."
  },
  {
    title: "Baga Beach",
    description: "Baga Beach is a popular destination for nightlife, beach shacks, water activities, seafood restaurants, and family vacations. It is among the most requested drop locations from Belgaum."
  },
  {
    title: "Candolim",
    description: "Candolim is known for luxury resorts, peaceful beaches, cafés, and beachside accommodations, making it a preferred destination for couples and family travelers."
  },
  {
    title: "Panaji",
    description: "Panaji, the capital of Goa, is famous for its colonial architecture, casinos, riverside promenade, shopping streets, churches, and cultural attractions."
  },
  {
    title: "Dabolim Airport",
    description: "Goa Dabolim Airport is a major travel hub for domestic and international passengers. Belgaum to Goa airport cabs provide convenient pickup and drop services."
  },
  {
    title: "Mopa Airport",
    description: "Manohar International Airport (Mopa) serves North Goa and nearby tourist destinations. It is a preferred airport for travelers visiting beaches and resorts in North Goa."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is one of South Goa's most scenic beaches, famous for its calm waters, beach huts, kayaking, and peaceful surroundings."
  },
  {
    title: "Colva Beach",
    description: "Colva Beach is a beautiful South Goa destination known for white sand, coconut trees, seafood restaurants, and relaxing beach holidays."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a historic Portuguese fort overlooking the Arabian Sea, offering panoramic coastal views and serving as one of Goa's most visited landmarks."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is famous for its flea market, nightlife, beach cafés, live music, and scenic coastline, making it a favorite destination for tourists visiting Goa."
  }
],





"services": [
  {
    "name": "Belgaum to Goa Cab",
    "description": "Book Belgaum to Goa Cab for safe, comfortable, and affordable travel with professional drivers, clean AC Sedan, Ertiga, Innova Crysta, and SUV vehicles. Enjoy fixed fares, doorstep pickup, online booking, one way and round trip options, airport transfers, sightseeing tours, family vacations, and 24x7 customer support."
  },
  {
    "name": "Belgaum to Goa Taxi",
    "description": "Choose Belgaum to Goa Taxi for reliable intercity travel with experienced chauffeurs, transparent pricing, comfortable vehicles, luggage assistance, and convenient pickup and drop services across North Goa and South Goa."
  },
  {
    "name": "Belgaum Airport to Goa Taxi Fare",
    "description": "Check Belgaum Airport to Goa Taxi Fare with fixed pricing, affordable packages, AC vehicles, and professional drivers for comfortable airport transfers to any Goa destination."
  },
  {
    "name": "Belgaum to Goa Airport Taxi Charges",
    "description": "Know Belgaum to Goa Airport Taxi Charges with transparent fares, no hidden costs, multiple vehicle options, and reliable airport transportation services."
  },
  {
    "name": "Belgaum to Goa Cab Price",
    "description": "Find Belgaum to Goa Cab Price for Sedan, Ertiga, Innova Crysta, and SUV vehicles with fixed rates, comfortable travel, and 24x7 booking assistance."
  },
  {
    "name": "Belgaum to Goa Cab Rates",
    "description": "Check Belgaum to Goa Cab Rates with affordable pricing, one way and round trip packages, premium vehicles, and experienced chauffeurs."
  },
  {
    "name": "Belgaum to Goa Cabs",
    "description": "Book Belgaum to Goa Cabs with clean AC cars, courteous drivers, online reservations, and comfortable travel for families, tourists, and business travelers."
  },
  {
    "name": "Belgaum to Goa Taxi Drop",
    "description": "Reserve Belgaum to Goa Taxi Drop with doorstep pickup, direct destination drop, fixed pricing, and professional chauffeur-driven vehicles."
  },
  {
    "name": "Belgaum to Goa Taxi Fare",
    "description": "Check Belgaum to Goa Taxi Fare with transparent pricing, affordable packages, multiple cab options, and comfortable outstation transportation."
  },
  {
    "name": "Belgaum to Goa Taxi Price",
    "description": "Get the best Belgaum to Goa Taxi Price with economical fares, premium vehicles, experienced drivers, and reliable intercity travel services."
  },
  {
    "name": "Belgaum to Goa Cab Booking",
    "description": "Complete Belgaum to Goa Cab Booking online with instant confirmation, secure reservations, flexible pickup timings, and multiple vehicle choices."
  },
  {
    "name": "Belgaum to Goa One Day Trip",
    "description": "Plan a Belgaum to Goa One Day Trip with comfortable AC cabs, sightseeing stops, experienced chauffeurs, flexible schedules, and hassle-free travel."
  },
  {
    "name": "Belgaum to Goa Cab Service",
    "description": "Choose Belgaum to Goa Cab Service for one way, round trip, airport transfers, family vacations, business travel, and sightseeing with premium vehicles."
  },
  {
    "name": "Belgaum to Goa Taxi Price",
    "description": "Compare Belgaum to Goa Taxi Price with fixed fares, affordable travel packages, comfortable vehicles, and reliable chauffeur-driven service."
  },
  {
    "name": "Belgaum to Goa Cab Service",
    "description": "Book Belgaum to Goa Cab Service with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for safe, comfortable, and punctual travel."
  },
  {
    "name": "Belgaum to Goa Taxi Service",
    "description": "Travel with Belgaum to Goa Taxi Service offering clean AC vehicles, experienced drivers, fixed pricing, and dependable outstation transportation."
  },
  {
    "name": "Belgaum to Goa One Way Cab",
    "description": "Reserve Belgaum to Goa One Way Cab with affordable fares, direct destination drop, online booking, and professional chauffeurs."
  },
  {
    "name": "Belgaum to Goa Cab Booking",
    "description": "Book Belgaum to Goa Cab Booking with instant confirmation, transparent pricing, multiple vehicle options, and 24x7 customer assistance."
  },
  {
    "name": "Belgaum to Goa Car Rental",
    "description": "Hire Belgaum to Goa Car Rental for flexible travel with Sedan, Ertiga, Innova Crysta, SUVs, and chauffeur-driven vehicles for leisure or business."
  },
  {
    "name": "Belgaum to Goa Outstation Cab",
    "description": "Choose Belgaum to Goa Outstation Cab for reliable long-distance travel with fixed fares, comfortable seating, and experienced drivers."
  },
  {
    "name": "Belgaum to Goa Airport Cab",
    "description": "Book Belgaum to Goa Airport Cab with timely airport pickup and drop, spacious luggage capacity, AC vehicles, and dependable service."
  },
  {
    "name": "Belgaum to Goa Airport Taxi",
    "description": "Reserve Belgaum to Goa Airport Taxi for smooth airport transfers with professional chauffeurs, fixed pricing, and comfortable travel."
  },
  {
    "name": "Belgaum to North Goa Cab",
    "description": "Travel with Belgaum to North Goa Cab for convenient transfers to Calangute, Baga, Candolim, Anjuna, Vagator, and other popular destinations."
  },
  {
    "name": "Belgaum to South Goa Cab",
    "description": "Book Belgaum to South Goa Cab for comfortable travel to Colva, Benaulim, Palolem, Varca, Cavelossim, and other South Goa beaches."
  },
  {
    "name": "Belgaum to Goa Innova Cab",
    "description": "Hire Belgaum to Goa Innova Cab for spacious family travel, group tours, airport transfers, and premium intercity journeys."
  },
  {
    "name": "Belgaum to Goa Ertiga Cab",
    "description": "Reserve Belgaum to Goa Ertiga Cab for affordable six-seater travel with comfortable seating, luggage space, and professional drivers."
  },
  {
    "name": "Belgaum to Goa Round Trip Cab",
    "description": "Book Belgaum to Goa Round Trip Cab with flexible return schedules, transparent pricing, experienced chauffeurs, and premium vehicles."
  },
  {
    "name": "Belgaum to Goa Tour Package by Cab",
    "description": "Choose Belgaum to Goa Tour Package by Cab for sightseeing, beaches, temples, churches, family vacations, and customized travel itineraries with chauffeur-driven vehicles."
  },
  {
    "name": "Cheap Belgaum to Goa Cab",
    "description": "Find Cheap Belgaum to Goa Cab with budget-friendly fares, clean AC vehicles, safe travel, experienced drivers, and no hidden charges."
  },
  {
    "name": "Best Belgaum to Goa Cab Service",
    "description": "Experience the Best Belgaum to Goa Cab Service with premium vehicles, courteous chauffeurs, fixed fares, 24x7 booking support, and comfortable travel for tourists, families, and corporate travelers."
  }
],

"tableData": [
  ["Belgaum to Goa Cab", "Belgaum to Goa Taxi"],
  ["Belgaum Airport to Goa Taxi Fare", "Belgaum to Goa Airport Taxi Charges"],
  ["Belgaum to Goa Cab Price", "Belgaum to Goa Cab Rates"],
  ["Belgaum to Goa Cabs", "Belgaum to Goa Taxi Drop"],
  ["Belgaum to Goa Taxi Fare", "Belgaum to Goa Taxi Price"],
  ["Belgaum to Goa Cab Booking", "Belgaum to Goa One Day Trip"],
  ["Belgaum to Goa Cab Service", "Belgaum to Goa Taxi Service"],
  ["Belgaum to Goa One Way Cab", "Belgaum to Goa Car Rental"],
  ["Belgaum to Goa Outstation Cab", "Belgaum to Goa Airport Cab"],
  ["Belgaum to Goa Airport Taxi", "Belgaum to North Goa Cab"],
  ["Belgaum to South Goa Cab", "Belgaum to Goa Innova Cab"],
  ["Belgaum to Goa Ertiga Cab", "Belgaum to Goa Round Trip Cab"],
  ["Belgaum to Goa Tour Package by Cab", "Cheap Belgaum to Goa Cab"],
  ["Best Belgaum to Goa Cab Service", ""]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Goa Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service offers reliable Belgaum to Goa cab services with experienced drivers, clean vehicles, and comfortable travel for leisure, family, and business trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Belgaum",
    WhyChoosedescription: "Enjoy convenient pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby areas with direct drop anywhere in Goa."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Goa Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with the Belgaum to Goa highway, ensuring a safe, smooth, and enjoyable journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cabs",
    WhyChoosedescription: "Whether you need a one-way taxi to Goa or a round-trip cab with flexible return timing, we provide travel options to suit your plans."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare",
    WhyChoosedescription: "Travel from Belgaum to Goa at competitive rates with transparent pricing, flexible packages, and no hidden charges."
  },
  {
    WhyChooseheading: "Perfect for Holidays & Business Travel",
    WhyChoosedescription: "Our Belgaum to Goa cabs are ideal for beach vacations, sightseeing tours, family holidays, corporate travel, and weekend getaways."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Book your Belgaum to Goa cab anytime with quick confirmation and dedicated customer support for a hassle-free travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Goa cab service?",
    answer: "Yes, Belgaum Taxi Service offers reliable one-way and round-trip cab services from Belgaum to Goa."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Goa?",
    answer: "Yes, one-way taxi services are available with doorstep pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Goa travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers depending on your travel requirements."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup is available from Belgaum Airport, Railway Station, hotels, offices, and residential areas."
  },
  {
    question: "Is Belgaum to Goa cab service available 24 hours?",
    answer: "Yes, our taxi services are available 24/7 for your preferred departure time."
  },
  {
    question: "Can I book a return cab from Goa to Belgaum?",
    answer: "Yes, round-trip and return cab services are available with flexible travel schedules."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state taxes, and applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Can I hire a cab for Goa sightseeing after reaching Goa?",
    answer: "Yes, customized Goa sightseeing packages and multi-day cab services can be arranged based on your itinerary."
  },
  {
    question: "Is this service suitable for family and group travel?",
    answer: "Yes, we provide spacious vehicles for families, friends, corporate groups, and tourists travelling from Belgaum to Goa."
  },
  {
    question: "How can I book a Belgaum to Goa Cab?",
    answer: "Share your pickup location, Goa destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Kulkarni",
    feedback: "Our Belgaum to Goa trip was comfortable from start to finish. The taxi was clean, the driver was courteous, and the journey was pleasant throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Naik",
    feedback: "The booking process was quick and hassle-free. The vehicle arrived on time, offered excellent comfort, and made our family vacation to Goa enjoyable.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Goa Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-goa-cab.webp",
  "description":
    "Book Belgaum to Goa Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Goa, Goa Airport, Calangute, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-goa-cab"
  }
};


    return (
        <div>



<Helmet>
  <title>Belgaum to Goa Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Goa Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Travel from Belgaum to Goa, Goa Airport, Calangute, and nearby locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="belgaum to goa cab, belgaum to goa taxi, belgaum airport to goa taxi fare, belgaum to goa airport taxi charges, belgaum to goa cab price, belgaum to goa cab rates, belgaum to goa cabs, belgaum to goa taxi drop, belgaum to goa taxi fare, belgaum to goa taxi price, belgaum to goa one way cab, Belgaum Goa Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtogoacab;